import { gql } from 'graphql.macro';

export const CreateIssue = gql`
    mutation createIssue($request: IssueRequestModelInput) {
        createIssue(request: $request) {observationId, uniqueRecordId}
    }
`;